import styled, { css } from 'styled-components';
import { getFieldPadding } from '../utils.js';
import { getColorAlias, getFontSize, getDefaultTransition, getSpacing, getDarkenColor } from '../../../utils/index.js';
import { fadeIn } from '../../../utils/styles.js';
import { Prefix } from '../textField/styles.js';

const SelectInput = styled.button `
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.hasText ? 'space-between' : 'flex-end')};
  width: 100%;
  color: ${(props) => getColorAlias(props.disabled ? 'contentDisabled' : 'contentDefault')};
  background: ${(props) => props.disabled ? getColorAlias('disabled01') : 'transparent'};
  ${getFontSize('size16')};
  ${(props) => getFieldPadding(props.variant)};
  border: none;
  border-radius: ${(props) => props.theme.radius.roundedC};
  width: 100%;
  ${getDefaultTransition('background')};
  align-items: center;

  &:hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }

  &:focus:hover {
    background: ${(props) => props.disabled
    ? getColorAlias('disabled01')
    : getColorAlias('containerDefault')};
  }

  input {
    left: 0;
    width: 100%;
    bottom: 0;
    opacity: 0;
    position: absolute;
    pointer-events: none;
  }

  span {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }

  svg {
    fill: ${(props) => props.disabled
    ? getColorAlias('disabled01')
    : getColorAlias('contentDefault')};
  }
`;
const OptionsPopper = styled.div `
  max-height: ${(props) => `${props.maxHeight}px`};
  z-index: 999;
  overflow-y: auto;
  overflow-x: hidden;
  background: ${getColorAlias('containerDefault')};
  font-family: ${(props) => props.theme.font.familyPrimary};
  border-radius: ${(props) => props.theme.radius.roundedC};
  padding: ${getSpacing('s02', 's00')};
  width: ${(props) => `${props.width}px`};
  box-shadow: ${(props) => props.theme.elevation.e3};
  ${(props) => css `
      animation: ${fadeIn} ${props.theme.motion.speed.defaultM}
        ${props.theme.motion.easing.easeDefault};
    `};

  &:active,
  &:focus,
  &:enabled {
    outline: none;
  }
`;
const OptionItem = styled.span `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${getSpacing('s03', 's04')};
  color: ${(props) => props.isDisabled
    ? getColorAlias('contentDisabled')
    : getColorAlias('contentDefault')};
  font-weight: ${(props) => props.isSelected
    ? props.theme.font.weightExtrabold
    : props.theme.font.weightRegular};
  font-family: ${(props) => props.theme.font.familyPrimary};
  ${getFontSize('size16')};
  ${getDefaultTransition()};

  cursor: pointer;
  background: ${(props) => getColorAlias(props.isHovered ? 'disabled01' : 'containerDefault')};

  &:hover {
    background: ${getDarkenColor('hover02', 'containerDefault')};
  }
`;
const DropdownPrefix = styled(Prefix) `
  ${(props) => props.hasValue
    ? css `
          padding-left: ${getSpacing('s04')};
        `
    : css `
          padding: ${getSpacing('s00', 's04')};
        `};
`;

export { DropdownPrefix, OptionItem, OptionsPopper, SelectInput };
